import GameModel from "../../GameModel";
import { Settings } from "../../Settings";
import BigNum from "../math/BigNum";
import GameTime from "../time/GameTime";

export default class ValuePerTurnCalculator extends GameModel {
    /**
     * 
     * @param {GameTime} gameTime 
     * @param {number} batchSeconds
     * @param {number} penaltyFactor
     */
    constructor(gameTime, batchSeconds, penaltyFactor) {
        super();

        /**
         * @constant
         * @type {GameTime}
         */
        this.gameTime = gameTime;
        /**
         * @constant
         * @type {number}
         */
        this.batchTurnSize = batchSeconds * Settings.time.turnsPerSecond;
        /**
         * @constant
         * @type {BigNum}
         */
        this.penaltyFactor = new BigNum(penaltyFactor);

        //////////////////////////////////
        // Persisted Fields
        //////////////////////////////////

        /**
         * @constant
         * @type {BigNum}
         */
        this.sum = new BigNum(0);
        /**
         * @type {number}
         */
        this.startTurn = gameTime.turnNumber;

        /**
         * @constant
         * @type {BigNum}
         */
        this.valuePerTurn = new BigNum(0);
        
        /**
         * @constant
         * @type {BigNum[]}
         */
        this.rates = [];

        /**
         * @type {number}
         */
        this.rateIndex = 0;
    }

    /**
     * @param {BigNum} value 
     * @param {BigNum} valuePerTurnOut
     * @returns {BigNum}
     */
    add(value, valuePerTurnOut) {
        this.sum.add(value);

        const elapsed = this.gameTime.turnNumber - this.startTurn;
        if (elapsed > this.batchTurnSize) {

            //console.log('ValuePerTurnCalc.add() elapsed=' + elapsed + ' batch=' + this.batchTurnSize);

            // Calculate the value per turn
            this.sum.divNumber(elapsed);

            //console.log('ValuePerTurnCalc.add() rate val=' + this.sum.toString());

            // Add to the rolling average.
            this.addToRollingAverage(this.sum);

            this.calculateValuePerTurn();

            //console.log('ValuePerTurnCalc.add() new rate=' + this.valuePerTurn.toString());

            // Start a new batch.
            this.startTurn = this.gameTime.turnNumber;
            this.sum.setZero();
        }

        valuePerTurnOut.copy(this.valuePerTurn);
    }

    /**
     * @private
     * @param {BigNum} valuePerTurn 
     */
    addToRollingAverage(valuePerTurn) {
        if (this.rates.length < 10) {
            const rate = new BigNum(0);
            rate.copy(valuePerTurn);
            this.rates.push(rate);
            // Keep rate index at 0, so that when the rates array fills up, and we start replacing values,
            // we start at index 0, which is the oldest value.
        }
        else {
            this.rates[this.rateIndex].copy(valuePerTurn);
            this.rateIndex++;
            if (this.rateIndex >= this.rates.length) {
                this.rateIndex = 0;
            }
        }
    }

    /**
     * @private
     */
    calculateValuePerTurn() {
        this.valuePerTurn.setZero();
        if (this.rates.length > 0) {
            for (let i = 0; i < this.rates.length; i++) {
                this.valuePerTurn.add(this.rates[i]);
            }
            this.valuePerTurn.divNumber(this.rates.length);

            this.valuePerTurn.mul(this.penaltyFactor);
        }
    }

    /**
     * @override
     */
    resetFull() {
         this.sum.setZero();
         this.startTurn = this.gameTime.turnNumber;
         this.rates.length = 0;
         this.rateIndex = 0;
         this.valuePerTurn.setZero();
    }

    /**
     * @override
     */
    resetForPrestige() {
        this.startTurn = this.gameTime.turnNumber;
    }
}